// extracted by mini-css-extract-plugin
module.exports = {"card":"post-module--card--3XgbG","image":"post-module--image--1lAAt","link":"post-module--link--3dXAZ","date":"post-module--date--30CtN"};